import { AxiosResponse } from 'axios';
import { apiV2 } from './http';
import { ContractType } from './interfaces/contractType';

export function listContractTypes(): Promise<
  AxiosResponse<{
    results: ContractType[];
    total: number;
  }>
> {
  return apiV2.get('contracts/contract-types/list');
}
